import React from 'react';
import { Button, ButtonProps } from 'react-bootstrap';

interface SVButtonProps extends ButtonProps {
  children: React.ReactNode;
}

const SVButton: React.FC<SVButtonProps> = ({ children, ...props }) => (
  <Button {...props}>{children}</Button>
);

export default SVButton;
